export default "__VITE_ASSET__Ci7f9eJD__"